export const extractIconClassNames = (markup: string): string[] => {
  const classAttrRegex = /class="([^"]*)"/;
  const match = markup.match(classAttrRegex);
  if (match && match[1]) {      
      return match[1].split(' ');
  }
  // Return an empty array if no match is found
  return [];
};

export const addIconElement = (mainElement: HTMLElement, iconMarkup: string, position?: 'before'|'after', ariaHidden?: boolean): HTMLElement | undefined => {    
      const iconElement = document.createElement('i');
      let iconClasses: Array<string> =[];
      iconClasses = extractIconClassNames(iconMarkup);
      iconClasses.forEach(clss => iconElement.classList.add(clss));
      iconElement.setAttribute('aria-hidden', ariaHidden === false? 'false': 'true');
      if(position && position === 'before') {
        mainElement.prepend(iconElement);
      } else {
        mainElement.append(iconElement);
      }
    return mainElement;
  }